export enum EHarvestingView {
  HARVESTING = 'Harvesting',
  SELECTTRIP = 'SelectSynchrotron',
  SELECTCRYO = 'selectCryo',
  SELECTSOAKING = 'selectSoaking',
}

export const HarvestingViewTitleMapping = {
  [EHarvestingView.HARVESTING]: 'Harvesting',
  [EHarvestingView.SELECTTRIP]: 'Select Synchrotron Trip',
  [EHarvestingView.SELECTCRYO]: 'Select Cryoprotectant',
  [EHarvestingView.SELECTSOAKING]: 'Select Soaking',
};
